export const projectKpis = (scheduleApiData, costApiData) => {
    const kpis = [];


    if (scheduleApiData) {
        kpis.push(
            {
                key: "project-progress",
                label: "Delivery Progress",
                type: "progress",
                planDisplayText: "Planned",
                actualDisplayText: "Actual",
                plan: scheduleApiData?.planProgress || 0,
                actual: scheduleApiData?.actualProgress || 0,
                bg: getBGColor(scheduleApiData?.planProgress, scheduleApiData?.actualProgress),//"#FEC7C7",
                iconBg: getIconBGColor(scheduleApiData?.planProgress, scheduleApiData?.actualProgress),
                unit: "%"
            },
            {
                key: "project-start-date",
                label: "Mobilization Date",
                value: scheduleApiData?.projectStartDate,
                type: "date",
                bg: "#FFF4DE",
                iconBg: "#FF947A"
            },
            {
                key: "project-end-date",
                label: "Baseline Completion",
                value: scheduleApiData?.projectEndDate,
                type: "date",
                bg: "#FFF4DE",
                iconBg: "#FF947A"
            },
            {
                key: "anticipate-end-date",
                label: "Forecast Completion",
                value: scheduleApiData?.projectProjectedEndDate,
                type: "date",
                // bg: "#FEC7C7",
                // iconBg: "#FA5A7D",
                bg: getBGColor(scheduleApiData?.projectProjectedEndDate, scheduleApiData?.projectEndDate),//"#FEC7C7",
                iconBg: getIconBGColor(scheduleApiData?.projectProjectedEndDate, scheduleApiData?.projectEndDate),// "#FA5A7D",
            }
        );
    }
    if (costApiData) {
        kpis.push(
            {
                key: "project-value",
                label: "Approved Budget",
                value: costApiData?.baselinecost,
                type: "cost",
                bg: "#FFF4DE",
                iconBg: "#FF947A",
                subTexts: [
                    { label: "Hard Cost", value: costApiData?.baselinehardcost },
                    { label: "Soft Cost", value: costApiData?.baselinecosftcost },
                ],
                unit: "Cr."
            },
            {
                key: "project-value",
                label: "Baseline Cost",
                value: costApiData?.revisedbaselinecost,
                type: "cost",
                bg: getBGColor(costApiData?.revisedbaselinecost, costApiData?.baselinecost),// "#FFF4DE",
                iconBg: getIconBGColor(costApiData?.revisedbaselinecost, costApiData?.baselinecost),// "#FF947A",
                subTexts: [
                    { label: "Hard Cost", value: costApiData?.revisedbaselinehardcost },
                    { label: "Soft Cost", value: costApiData?.revisedbaselinecosftcost },
                ],
                unit: "Cr."
            },
            {
                key: "project-earned-value",
                label: "Earned Value Progress",
                plan: costApiData?.actual || 0,
                actual: costApiData?.earned || 0,
                type: "progress",
                planDisplayText: "Actual",
                actualDisplayText: "Earned",
                bg: getBGColor(costApiData?.actual, costApiData?.earned),// "#FEC7C7",
                iconBg: getIconBGColor(costApiData?.actual, costApiData?.earned),// "#FA5A7D",
                unit: "Cr."
            }
        );
    }

    return kpis;
};


export const costKpiData = (costKpi) => {

    return [
        {
            label: "Baseline Cost",
            value: costKpi?.revisedbaselinecost,
            key: "baseline-cost",
            color: "#0088FF"
        },
        {
            label: "Estimate At Completion",
            value: costKpi?.eac,
            key: "estimate-at-completion",
            color:getIconBGColor(costKpi?.eac, costKpi?.revisedbaselinecost)// "#1A932E"
        },
        // {
        //     label: "Estimate to Completion  (ETC)",
        //     value: "233.92 Cr",
        //     key: "estimate-to-completion",
        //     color: "#FF8D28"
        // },
    ]
}

const getBGColor = (planned, actual) => {
    if((actual ==null && planned==null) ||(actual ==0 && planned==0) )
        return "#FFF4DE";
    else if (actual >= planned) {
        return "#DCFCE7"
    }
    else {
        return "#FEC7C7"
    }

}
const getIconBGColor = (planned, actual) => {
    if((actual ==null && planned==null) ||(actual ==0 && planned==0) )
        return "#FF947A";
    else if (actual >= planned) {
        return "#3CD856"
    }
    else {
        return "#FA5A7D"
    }
}
